import { render, staticRenderFns } from "./dialogChangePassword.vue?vue&type=template&id=846c3a54&scoped=true&"
import script from "./dialogChangePassword.vue?vue&type=script&lang=js&"
export * from "./dialogChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./dialogChangePassword.vue?vue&type=style&index=0&id=846c3a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846c3a54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VSpacer,VTextField})
